import api from '../collums-components/api/config';

class CourseCategory {
    static getCategories(query) {
        return api.request({
            method: 'GET',
            url: `/course/categories${query}`
        });
    }

    static getCategory(categoryId) {
        return api.request({
            method: 'GET',
            url: `/course/categories/${categoryId}`
        });
    }

    static filter(value = '', isSub = false, isFromOrg = false) {
        return api.request({
            method: 'GET',
            url: `/course/categories/filterBy?name=${value}&isSub=${isSub}&isFromOrg=${isFromOrg}`
        });
    }

    static createCategory(data) {
        return api.request({
            method: 'POST',
            url: '/course/categories',
            data: data
        });
    }

    static updateCategory(categoryId, data, clinic, isFromOrg = false) {
        return api.request({
            method: 'PUT',
            url: `/course/categories/${categoryId}?clinic=${clinic}&isFromOrg=${isFromOrg}`,
            data: data
        });
    }

    static deleteCategory(categoryId) {
        return api.request({
            method: 'DELETE',
            url: `/course/categories/${categoryId}`
        });
    }

    static archiveCategory(categoryId, value, clinic, isFromOrg = false) {
        return api.request({
            method: 'POST',
            url: `/course/categories/${categoryId}/archive?value=${value}&clinic=${clinic}&isFromOrg=${isFromOrg}`
        });
    }

    static changeActiveCategory(categoryId, value, clinic, isFromOrg = false) {
        return api.request({
            method: 'PUT',
            url: `/course/categories/${categoryId}/change-active?value=${value}&clinic=${clinic}&isFromOrg=${isFromOrg}`
        });
    }

    static changeCategoryShowOnline(categoryId, value, clinic, isFromOrg = false) {
        return api.request({
            method: 'PUT',
            url: `/course/categories/${categoryId}/change-show-online?value=${value}&clinic=${clinic}&isFromOrg=${isFromOrg}`
        });
    }
}

export default CourseCategory;
